import { jsx as _jsx } from "react/jsx-runtime";
import { Suspense, useContext } from "react";
import { useConfigurationAttributeInfo, useConfigurationObjectInfo, useConfigurationValueInfo, } from "@plansoft-configuration-renderer/framework";
import { InfoComponentsContext } from "./InfoComponents";
export function ConfigurationObjectInfo(props) {
    const InfoComponents = useContext(InfoComponentsContext);
    const info = useConfigurationObjectInfo();
    return (_jsx(Suspense, { children: _jsx(InfoComponents.Info, Object.assign({}, info, props)) }));
}
export function ConfigurationAttributeInfo(props) {
    const InfoComponents = useContext(InfoComponentsContext);
    const info = useConfigurationAttributeInfo();
    return (_jsx(Suspense, { children: _jsx(InfoComponents.Info, Object.assign({}, info, props)) }));
}
export function ConfigurationValueInfo(props) {
    const InfoComponents = useContext(InfoComponentsContext);
    const info = useConfigurationValueInfo();
    return (_jsx(Suspense, { children: _jsx(InfoComponents.Info, Object.assign({}, info, props)) }));
}
//# sourceMappingURL=ConfigurationItemInfo.js.map